import QuestionIcon from 'components/Common/SvgIcons/QuestionIcon'
import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'App'
import { useFeatureFlag } from 'hooks/userFeatureFlag'
import { helpDesk } from 'utils/helper'

const GetHelpCard = () => {
  const user = useSelector((state: RootState) => state.user.user)
  const helpDeskEnabled = useFeatureFlag(user?.id || '', 'release-chatbot-get-help')

  if (!helpDeskEnabled) {
    return null
  }

  return (
    <div className="rounded-[20px] bg-gradient-to-r from-[#52B4F9] to-[#8400F7] xs:w-full sm:max-w-[325px] p-6">
      <div className="flex justify-between gap-4">
        <div
          onClick={(e) => {
            e.preventDefault()
            helpDesk()
          }}
        >
          <QuestionIcon className="shrink-0 cursor-pointer" />
        </div>
        <p className="text-white font-bold font-base leading-5">
          Get help with tool setup from GoTackle Support
        </p>
      </div>
    </div>
  )
}

export default GetHelpCard
